import "./CategoriesPage.css";
import { useEffect, useState } from "react";
import Category from "../components/Category";
import { addCategory, Cat, fetchCategories } from "../api/categories";
import { Button, Dialog, TextField } from "@mui/material";

export default function CategoriesPage() {
  const [cats, setCats] = useState<Cat[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [newCat, setNewCat] = useState<string>("");
  async function update() {
    setLoading(true);
    const data = await fetchCategories();
    setCats(data);
    setLoading(false);
  }
  useEffect(() => {
    update();
  }, []);

  function addCategoryClicked(_event: any): void {
    setDialogOpen(true);
  }
  async function addCat(): Promise<void> {
    await addCategory(newCat);
    await update();
    setDialogOpen(false);
  }

  return (
    <div className="Categories">
      <div className="Categories-header">Categories</div>
      <div>
        <Button
          variant="outlined"
          onClick={addCategoryClicked}
          style={{ margin: "15px" }}
        >
          Add
        </Button>
      </div>
      {loading && <div className="Categories-loading">Loading...</div>}
      {!loading && cats.length === 0 && (
        <div className="Categories-empty">No categories available</div>
      )}
      {!loading &&
        cats.length > 0 &&
        cats.map((cat) => (
          <Category id={cat.categoryid} name={cat.name} key={cat.categoryid} />
        ))}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <div className="Categories-dialog">
          <h2>Add Category</h2>
          <TextField
            variant="outlined"
            label="Name"
            value={newCat}
            onChange={(e) => setNewCat(e.target.value)}
            style={{ margin: "10px" }}
            autoFocus
          />
          <Button variant="contained" onClick={addCat}>
            Save
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
